import { EnumExamType, EXAM_TYPE } from '@/constants'

const zhumavip = 'zhumavip'
const zhongheschool = 'zhongheschool'
export const tokenInit = (token) => {
  // return `https://test.zhongheschool.com/java-api/api/office/userLogin/tokenInit?token=${token}`
  const url = window.location.origin
  let newUrl
  if (url.includes(zhongheschool)) {
    newUrl = url.replace(zhongheschool, zhumavip)
  }
  if (url.includes(zhumavip)) {
    newUrl = url.replace(zhumavip, zhongheschool)
  }
  return `${newUrl}/java-api/api/office/userLogin/tokenInit?token=${token}`
}


export const logoutTokenDestruction = () => {
  const url = window.location.origin
  let newUrl
  if (url.includes(zhongheschool)) {
    newUrl = url.replace(zhongheschool, zhumavip)
  }
  if (url.includes(zhumavip)) {
    newUrl = url.replace(zhumavip, zhongheschool)
  }
  return `${newUrl}/java-api/api/office/userLogin/tokenDestruction`
}


export const httpToHttps = () => {
  if (process.env.IS_DEV) return
  if (window.location.protocol !== 'https:') {
    window.location.href = 'https:' + window.location.href.substring(window.location.protocol.length)
  }
}


export const removeProtocol =  ()=>{
  // 本地运行会有问题 return location.href
  if (process.env.IS_DEV) return location.href
  let href= window.location.href
  if (href.split(':') && href.split(':')[1]){
    href = href.split(':')[1]
  }
  return href
}
// 判断用户操作系统
export const typeOs = () => {
  let agent = navigator.userAgent.toLowerCase()
  let isMac = /macintosh|mac os x/i.test(navigator.userAgent)
  let os = null

  if (agent.indexOf('win32') >= 0 || agent.indexOf('wow32') >= 0) {
    os = 'windows'
  }
  if (agent.indexOf('win64') >= 0 || agent.indexOf('wow64') >= 0) {
    os = 'windows'
  }
  if (isMac) {
    os = 'mac'
  }

  return os
}

export const showZoomTips = (ref) => {
  // 用户浏览器缩放比例异常时，弹窗提示
  const detectZoomNum = detectZoom()
  const os = typeOs()
  if (os == 'mac') {
    if (detectZoomNum > 400 || detectZoomNum < 100) {
      ref.current?.show()
    } else {
      ref.current?.hide()
    }
  } else if (os == 'windows') {
    if (detectZoomNum > 300 || detectZoomNum < 75) {
      ref.current?.show()
    } else {
      ref.current?.hide()
    }
  }
}

// 检测浏览器缩放比例
export const detectZoom = () => {
  let ratio = 0,
    screen = window.screen,
    ua = navigator.userAgent.toLowerCase()

  if (window.devicePixelRatio !== undefined) {
    ratio = window.devicePixelRatio
  } else if (~ua.indexOf('msie')) {
    if (screen.deviceXDPI && screen.logicalXDPI) {
      ratio = screen.deviceXDPI / screen.logicalXDPI
    }
  } else if (
    window.outerWidth !== undefined &&
    window.innerWidth !== undefined
  ) {
    ratio = window.outerWidth / window.innerWidth
  }
  if (ratio) {
    ratio = Math.round(ratio * 100)
  }
  return ratio
}


// 是否是模考
export const isMockExam = () => {
  const params = new URLSearchParams(window.location.search)
  return Number(params.get(EXAM_TYPE)) === EnumExamType.MOCK
}

// 是否是一题一练
export const isOne = () => {
  const params = new URLSearchParams(window.location.search)
  return !!params.get('one')
}




// 更换crm域名的host
export const changeCdnCrmHost = originalUrl => {
  const domainToReplace = 'zhonghecrm.oss-cn-zhangjiakou.aliyuncs.com'
  const replacementDomain = 'crmoss.zhongheschool.com'
  return originalUrl.replace(domainToReplace, replacementDomain)
}


export const isHttpLink = (url) => {
  var pattern = /^(http|https):\/\//;
  return pattern.test(url);
}

// 判断当前域名是否是竹马
export const isZhumavip = () => {
  return window.location.host.indexOf('zhuma') !== -1
}
